import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 align-items-center" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_11 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_12 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_13 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_20 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_21 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_22 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_29 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_30 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_31 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "col-lg-8 fv-row" }
const _hoisted_43 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_44 = { class: "d-flex fv-row" }
const _hoisted_45 = { class: "col-lg-6" }
const _hoisted_46 = { class: "card-header border-0 align-items-center" }
const _hoisted_47 = { class: "card-title m-0" }
const _hoisted_48 = { class: "fw-bolder m-0" }
const _hoisted_49 = { class: "collapse show" }
const _hoisted_50 = { class: "card-body border-top p-9" }
const _hoisted_51 = { class: "row mb-6" }
const _hoisted_52 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "col-lg-8 fv-row" }
const _hoisted_54 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "row mb-6" }
const _hoisted_56 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "col-lg-8 fv-row" }
const _hoisted_58 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "row mb-6" }
const _hoisted_60 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "col-lg-8 fv-row" }
const _hoisted_62 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_63 = { class: "row mb-6" }
const _hoisted_64 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-lg-8 fv-row" }
const _hoisted_66 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_67 = { class: "col-lg-6" }
const _hoisted_68 = { class: "card-header border-0 align-items-center" }
const _hoisted_69 = { class: "card-title m-0" }
const _hoisted_70 = { class: "fw-bolder m-0" }
const _hoisted_71 = { class: "collapse show" }
const _hoisted_72 = { class: "card-body border-top p-9" }
const _hoisted_73 = { class: "row mb-6" }
const _hoisted_74 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_75 = { class: "col-lg-8 fv-row" }
const _hoisted_76 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_77 = { class: "row mb-6" }
const _hoisted_78 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "col-lg-8 fv-row" }
const _hoisted_80 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_81 = { class: "row mb-6" }
const _hoisted_82 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "col-lg-8 fv-row" }
const _hoisted_84 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_85 = { class: "row mb-6" }
const _hoisted_86 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_87 = { class: "col-lg-8 fv-row" }
const _hoisted_88 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_89 = { class: "d-flex fv-row" }
const _hoisted_90 = { class: "col-lg-6" }
const _hoisted_91 = { class: "card-header border-0 align-items-center" }
const _hoisted_92 = { class: "card-title m-0" }
const _hoisted_93 = { class: "fw-bolder m-0" }
const _hoisted_94 = { class: "collapse show" }
const _hoisted_95 = { class: "card-body border-top p-9" }
const _hoisted_96 = { class: "row mb-6" }
const _hoisted_97 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_98 = { class: "col-lg-4 fv-row" }
const _hoisted_99 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_100 = { class: "row mb-6" }
const _hoisted_101 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_102 = { class: "col-lg-4 fv-row" }
const _hoisted_103 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_104 = { class: "row mb-6" }
const _hoisted_105 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_106 = { class: "col-lg-4 fv-row" }
const _hoisted_107 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_108 = { class: "row mb-6" }
const _hoisted_109 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_110 = { class: "col-lg-4 fv-row" }
const _hoisted_111 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_112 = { class: "row mb-6" }
const _hoisted_113 = { class: "col-lg-8 col-form-label fw-bold fs-6" }
const _hoisted_114 = { class: "col-lg-4 fv-row" }
const _hoisted_115 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_116 = { class: "col-lg-6" }
const _hoisted_117 = { class: "card-header border-0 align-items-center" }
const _hoisted_118 = { class: "card-title m-0" }
const _hoisted_119 = { class: "fw-bolder m-0" }
const _hoisted_120 = { class: "collapse show" }
const _hoisted_121 = { class: "card-body border-top p-9" }
const _hoisted_122 = { class: "row mb-6" }
const _hoisted_123 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_124 = { class: "col-lg-8 fv-row" }
const _hoisted_125 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_126 = { class: "row mb-6" }
const _hoisted_127 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_128 = { class: "col-lg-8 fv-row" }
const _hoisted_129 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_130 = { class: "row mb-6" }
const _hoisted_131 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_132 = { class: "col-lg-8 fv-row" }
const _hoisted_133 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_134 = { class: "row mb-6" }
const _hoisted_135 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_136 = { class: "col-lg-8 fv-row" }
const _hoisted_137 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_138 = { class: "row mb-6" }
const _hoisted_139 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_140 = { class: "col-lg-8 fv-row" }
const _hoisted_141 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_142 = { class: "row mb-6" }
const _hoisted_143 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_144 = { class: "col-lg-8 fv-row" }
const _hoisted_145 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_146 = { class: "row mb-6" }
const _hoisted_147 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_148 = { class: "col-lg-8 fv-row" }
const _hoisted_149 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_150 = { class: "row mb-6" }
const _hoisted_151 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_152 = { class: "col-lg-8 fv-row" }
const _hoisted_153 = { class: "col-lg-4 col-form-label fw-bold fs-6" }

import { showBackendError } from "@/assets/ts/_utils/ShowBackendError";
import { diffObjects } from "@/core/helpers/diffObjects";
import { AuthModule, ProyectosN2ListadoModule } from "@/store/modules";
import { ElNotification } from "element-plus";
import { ErrorMessage, useField, useForm } from "vee-validate";
import { computed, onBeforeMount, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface FormState {
  criteriosPreferentesAcceso?: string | null;
  requisitosExigiblesPersonaEmpleada?: string | null;
  requisitosExigiblesEmpresaEmpleadora?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const module = getModule(ProyectosN2ListadoModule, store);
const authModule = getModule(AuthModule, store);
const comarcaId = authModule.user.comarcaId;
const route = useRoute();
const token = route.params.id as string;

const creacionEmpleo = computed(() => module.proyectoN2?.creacionEmpleo);

const editingCreacionEmpleo = ref<boolean>(false);

const schema = Yup.object({
  criteriosPreferentesAcceso: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.bolsaCuidados.campos.tipoServicio")),
  requisitosExigiblesPersonaEmpleada: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.bolsaCuidados.campos.requisitos")),
  requisitosExigiblesEmpresaEmpleadora: Yup.string()
    .nullable()
    .label(t("formulario.proyecto.bolsaCuidados.campos.lugarPrestacion")),
});

const { resetForm, handleSubmit, meta } = useForm<Partial<FormState>>({
  validationSchema: schema,
});

const guardaDetalle = ref<boolean>(false);
const guardarCreacionEmpleo = handleSubmit(async (values) => {
  guardaDetalle.value = true;

  const update = diffObjects(meta.value.initialValues, values);
  if (Object.keys(update).length) {
    await module
      .patchEmpleoById({
        id: token,
        comarcaId: comarcaId,
        creacionEmpleo: {
          ...update,
        },
      })
      .then(() => {
        ElNotification({
          message: t("formularios.proyectosN2.guardar.mensaje.exito"),
          type: "success",
        });
        editingCreacionEmpleo.value = false;
        module.fetchById({ comarcaId: comarcaId, id: token as string });
      })
      .catch((err) => {
        if (typeof err === "object" && err?.error?.statusCode < 500) {
          showBackendError(t, err.error);
        } else {
          ElNotification({
            message: t("formularios.proyectosN2.cargar.error"),
            type: "error",
          });
        }
      })
      .finally(() => {
        guardaDetalle.value = false;
      });
  } else {
    ElNotification({
      message: t("formularios.proyectosN2.guardar.mensaje.exito"),
      type: "success",
    });
    editingCreacionEmpleo.value = false;
    module.fetchById({ comarcaId: comarcaId, id: token as string });
    guardaDetalle.value = false;
  }
});

onBeforeMount(() => {
  // load();
});

watch(editingCreacionEmpleo, () => {
  resetForm({
    values: {
      criteriosPreferentesAcceso:
        creacionEmpleo.value?.criteriosPreferentesAcceso,
      requisitosExigiblesPersonaEmpleada:
        creacionEmpleo.value?.requisitosExigiblesPersonaEmpleada,
      requisitosExigiblesEmpresaEmpleadora:
        creacionEmpleo.value?.requisitosExigiblesEmpresaEmpleadora,
    },
  });
});

const { value: criteriosPreferentesAcceso } = useField(
  "criteriosPreferentesAcceso"
);
const { value: requisitosExigiblesPersonaEmpleada } = useField(
  "requisitosExigiblesPersonaEmpleada"
);
const { value: requisitosExigiblesEmpresaEmpleadora } = useField(
  "requisitosExigiblesEmpresaEmpleadora"
);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formulario.proyecto.creacionEmpleo.titulo")), 1)
      ]),
      (!editingCreacionEmpleo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (editingCreacionEmpleo.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.editar.button")), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(guardarCreacionEmpleo),
              loading: guardaDetalle.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.guardar.button")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"]),
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (editingCreacionEmpleo.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.cancelar.button")), 1)
              ]),
              _: 1
            })
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t(
                "formulario.proyecto.creacionEmpleo.campos.criteriosPreferentesAcceso"
              )), 1),
          (!editingCreacionEmpleo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(creacionEmpleo)?.criteriosPreferentesAcceso ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "criteriosPreferentesAcceso",
                      placeholder: "",
                      modelValue: _unref(criteriosPreferentesAcceso),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(criteriosPreferentesAcceso) ? (criteriosPreferentesAcceso).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_unref(ErrorMessage), { name: "criteriosPreferentesAcceso" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t(
                "formulario.proyecto.creacionEmpleo.campos.requisitosExigiblesPersonaEmpleada"
              )), 1),
          (!editingCreacionEmpleo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(creacionEmpleo)?.requisitosExigiblesPersonaEmpleada ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "requisitosExigiblesPersonaEmpleada",
                      placeholder: "",
                      modelValue: _unref(requisitosExigiblesPersonaEmpleada),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(requisitosExigiblesPersonaEmpleada) ? (requisitosExigiblesPersonaEmpleada).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_unref(ErrorMessage), { name: "requisitosExigiblesPersonaEmpleada" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t(
                "formulario.proyecto.creacionEmpleo.campos.requisitosExigiblesEmpresaEmpleadora"
              )), 1),
          (!editingCreacionEmpleo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(creacionEmpleo)?.requisitosExigiblesEmpresaEmpleadora ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      name: "requisitosExigiblesEmpresaEmpleadora",
                      placeholder: "",
                      modelValue: _unref(requisitosExigiblesEmpresaEmpleadora),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(requisitosExigiblesEmpresaEmpleadora) ? (requisitosExigiblesEmpresaEmpleadora).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_unref(ErrorMessage), { name: "requisitosExigiblesEmpresaEmpleadora" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("formulario.proyecto.creacionEmpleo.campos.nPlazas")), 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(creacionEmpleo)?.nPlazas ?? "-"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("formulario.proyecto.creacionEmpleo.campos.nSolicitudes")), 1),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(creacionEmpleo)?.nSolicitudes ?? "-"), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.$t(
                  "formulario.proyecto.creacionEmpleo.campos.personasPorEdad.titulo"
                )), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorEdad.nPersonasMenores30"
                  )), 1),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(creacionEmpleo)?.nPersonasMenores30 ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorEdad.nPersonas30a45"
                  )), 1),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("label", _hoisted_58, _toDisplayString(_unref(creacionEmpleo)?.nPersonas30a45 ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorEdad.nPersonasMas45"
                  )), 1),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("label", _hoisted_62, _toDisplayString(_unref(creacionEmpleo)?.nPersonasMas45 ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorEdad.nPersonasEdadNC"
                  )), 1),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("label", _hoisted_66, _toDisplayString(_unref(creacionEmpleo)?.nPersonasEdadNC ?? "0"), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("h3", _hoisted_70, _toDisplayString(_ctx.$t(
                  "formulario.proyecto.creacionEmpleo.campos.personasPorGenero.titulo"
                )), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorGenero.nPersonasGeneroMujer"
                  )), 1),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("label", _hoisted_76, _toDisplayString(_unref(creacionEmpleo)?.nPersonasMujer ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorGenero.nPersonasGeneroVaron"
                  )), 1),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("label", _hoisted_80, _toDisplayString(_unref(creacionEmpleo)?.nPersonasVaron ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorGenero.nPersonasGeneroOtro"
                  )), 1),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("label", _hoisted_84, _toDisplayString(_unref(creacionEmpleo)?.nPersonasOtro ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorGenero.nPersonasGeneroNC"
                  )), 1),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("label", _hoisted_88, _toDisplayString(_unref(creacionEmpleo)?.nPersonasNC ?? "0"), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_89, [
      _createElementVNode("div", _hoisted_90, [
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("h3", _hoisted_93, _toDisplayString(_ctx.$t(
                  "formulario.proyecto.creacionEmpleo.campos.personasPorCaracteristicas.titulo"
                )), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorCaracteristicas.nMujeresLargaDuracion"
                  )), 1),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("label", _hoisted_99, _toDisplayString(_unref(creacionEmpleo)?.nMujeresLargaDuracion ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorCaracteristicas.nVaronesLargaDuracion"
                  )), 1),
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("label", _hoisted_103, _toDisplayString(_unref(creacionEmpleo)?.nVaronesLargaDuracion ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorCaracteristicas.nPersonasVictima"
                  )), 1),
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("label", _hoisted_107, _toDisplayString(_unref(creacionEmpleo)?.nPersonasVictima ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorCaracteristicas.nMujeresRefugiadas"
                  )), 1),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("label", _hoisted_111, _toDisplayString(_unref(creacionEmpleo)?.nMujeresRefugiadas ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("label", _hoisted_113, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorCaracteristicas.nVaronesRefugiados"
                  )), 1),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("label", _hoisted_115, _toDisplayString(_unref(creacionEmpleo)?.nVaronesRefugiados ?? "0"), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_116, [
        _createElementVNode("div", _hoisted_117, [
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("h3", _hoisted_119, _toDisplayString(_ctx.$t(
                  "formulario.proyecto.creacionEmpleo.campos.personasPorContrato.titulo"
                )), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_120, [
          _createElementVNode("div", _hoisted_121, [
            _createElementVNode("div", _hoisted_122, [
              _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorContrato.nPersonasIndefinido"
                  )), 1),
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("label", _hoisted_125, _toDisplayString(_unref(creacionEmpleo)?.nPersonasIndefinido ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_126, [
              _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorContrato.nPersonasTemporal"
                  )), 1),
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("label", _hoisted_129, _toDisplayString(_unref(creacionEmpleo)?.nPersonasTemporal ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_130, [
              _createElementVNode("label", _hoisted_131, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorContrato.nPersonasFijoDiscontinuo"
                  )), 1),
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("label", _hoisted_133, _toDisplayString(_unref(creacionEmpleo)?.nPersonasFijoDiscontinuo ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorContrato.nPersonasFormativo"
                  )), 1),
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("label", _hoisted_137, _toDisplayString(_unref(creacionEmpleo)?.nPersonasFormativo ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorContrato.nPersonasTipoContratoNC"
                  )), 1),
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("label", _hoisted_141, _toDisplayString(_unref(creacionEmpleo)?.nPersonasTipoContratoNC ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_142, [
              _createElementVNode("label", _hoisted_143, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorContrato.nPersonasJornadaCompleta"
                  )), 1),
              _createElementVNode("div", _hoisted_144, [
                _createElementVNode("label", _hoisted_145, _toDisplayString(_unref(creacionEmpleo)?.nPersonasJornadaCompleta ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_146, [
              _createElementVNode("label", _hoisted_147, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorContrato.nPersonasJornadaParcial"
                  )), 1),
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("label", _hoisted_149, _toDisplayString(_unref(creacionEmpleo)?.nPersonasJornadaParcial ?? "0"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_150, [
              _createElementVNode("label", _hoisted_151, _toDisplayString(_ctx.$t(
                    "formulario.proyecto.creacionEmpleo.campos.personasPorContrato.nPersonasJornadaNC"
                  )), 1),
              _createElementVNode("div", _hoisted_152, [
                _createElementVNode("label", _hoisted_153, _toDisplayString(_unref(creacionEmpleo)?.nPersonasJornadaNC ?? "0"), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})